import './utils/processPolyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/style.scss';
import './runtimeBranding.css';
import { setupWlDemoAxios } from './utils/wlDemoAxios';
import { getBrowserSessionReleaseExtras, getBrowserSessionArtistExtras } from './utils/browserSessionDemoApi';
import store from './redux/store';
import { addRelease } from './redux/releases/action';
import { hydrateArtistsFromSession } from './redux/artists/action';

setupWlDemoAxios();
getBrowserSessionReleaseExtras().forEach(row => {
  if (row && row.id != null) {
    store.dispatch(addRelease(row));
  }
});
store.dispatch(hydrateArtistsFromSession(getBrowserSessionArtistExtras()));

const App = require('./app').default;

ReactDOM.render(<App />, document.getElementById('root'));
